import styled from "styled-components";

export const MapContainer = styled.div`
    position: relative;
    width: 100%;
    height: 400px;
    margin-bottom: 10px;
`;

export const MapSearchBox = styled.div`
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 1;
    width: 80%;
    max-width: 47.5%;

    .form-control {
        height: 40px;
        border: 1px solid transparent;
        background-color: #fff;
        border-radius: 0.25rem;
        box-shadow: 0 .05rem .05rem rgba(0, 0, 0, 0.15);
    }

    .form-outline .form-control~.form-notch .form-notch-leading,
    .form-outline .form-control~.form-notch .form-notch-middle,
    .form-outline .form-control~.form-notch .form-notch-trailing {
        border: 1px solid transparent;
    }

    .form-outline .form-control:focus~.form-notch .form-notch-middle .form-label,
    .form-outline .form-control.active~.form-notch .form-notch-middle .form-label {
        display: none;
    }
`